import Config from '@/config'
import { logger } from '@/lib/logger'
import type { ApisauceInstance } from 'apisauce'
import { create } from 'apisauce'
import { authRequestInterceptor } from './interceptors/auth'
import type {
	PatientBillingRecord,
	PatientInfo,
	PatientMembershipCheckResponse,
} from './types/PatientApi'

export class PatientApi {
	_apiConfig: ApisauceInstance

	constructor() {
		this._apiConfig = create({
			baseURL: Config.PATIENT_API_URL_BASE,
			timeout: 10000,
		})

		this._apiConfig.axiosInstance.interceptors.request.use(authRequestInterceptor)
	}

	getPatientInfo() {
		return this._apiConfig
			.get('/patients/me')
			.then((response) => response.data as PatientInfo)
			.catch((error) => {
				logger.error(new Error('failed_to_get_patient_info', { cause: error }))
				return {} as PatientInfo
			})
	}

	getBillingRecord() {
		return this._apiConfig
			.get('/billing/patient-record')
			.then((response) => response.data as PatientBillingRecord)
			.catch((error) => {
				logger.error(new Error('failed_to_get_patient_billing_info', { cause: error }))
				return {} as PatientBillingRecord
			})
	}

	updatePrimaryCard({ token }: { token: string }) {
		return this._apiConfig
			.post('/billing/cards/patient/default', { token })
			.catch((error) => {
				logger.error(new Error('failed_to_update_primary_card', { cause: error }))
			})
	}

	updatePatientProfile({
		firstName,
		lastName,
		phone,
	}: { firstName?: string; lastName?: string; phone?: string }) {
		return this._apiConfig
			.post('/patients/update-info', { firstName, lastName, phone })
			.catch((error) => {
				logger.error(new Error('failed_to_update_patient_info', { cause: error }))
			})
	}

	getMembershipStatus() {
		return this._apiConfig.get('/patients/membership').then((response) => {
			return response.data as PatientMembershipCheckResponse
		})
	}
}

export const patientApi = new PatientApi()
